/** Django's CSRF token, which every write must echo. Null until the server has set its cookie. */
export function csrfToken(): string | null {
  const part = document.cookie.split('; ').find((one) => one.startsWith('csrftoken='));
  return part ? decodeURIComponent(part.slice('csrftoken='.length)) : null;
}
